// Variable definitions for project module
const state = { 
    projectData: [],
    criteriaTree: [],
    questionTree:[],
    projectValues:{},
    selectedProject: 0,
    selectedReferentialId: 0,
    canEditList: {
        projectTitle: true,
        projectDescription: true,
        projectModalOpen: false,
        confirmationDialogOpen: false,
    },
    confirmationObject: [],
    loading: false, 
    productionReferentials: [],
    generalData: [],
    /* answerQ: [], */
    answerQTest: [],
    evaluationCriteriaColor:[],
    evaluationQColor:[],
    selectedQuestion: 0,
    sharecode: [],
    userList: [],
    userListRightsProject: [],
    files:[],
    file : [],
    roles:false,
    filterBlackQuestionsActive: false,
    filterUnAnsweredQuestionsActive: false,
    projectErrors: [],
    criteriaEvaluation: [],
    tagValues: {},
    pdf:[],
    temPdf:[],
    graphData: {},
    evaluationLoaded: false,
    crunched:false,
}

export default state;